import { render, staticRenderFns } from "./LvDownloadFileBtn.vue?vue&type=template&id=7410db65"
import script from "./LvDownloadFileBtn.vue?vue&type=script&lang=js"
export * from "./LvDownloadFileBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports